import {Injectable} from '@angular/core';

import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Storage} from '@ionic/storage';
import {Observable} from 'rxjs';

import {UserService} from "../../services/UserService";


@Injectable()
export class InterceptorProvider implements HttpInterceptor {

  user: any;

  constructor(
    private storage: Storage,
    private userService: UserService
  ) {

    // this.user = this.userService.get();
  }


  /**
   * Intercepta todas las llamadas HTTP
   *
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(this.addToken(request));
  }


  /**
   * Añade el token en los Headers si hay sesion de usuairo y existe el token
   *
   */
  private addToken(request: HttpRequest<any>) {

    this.user = this.userService.get();

    if (this.user && 'token' in this.user) {

      let clone: HttpRequest<any>;

      clone = request.clone({
        setHeaders: {
          Accept: 'application/json',
          Authorization: this.user.token
        }
      });

      return clone;
    }

    return request;
  }
}



// WEBPACK FOOTER //
// ./src/providers/interceptor/interceptor.ts